import { action } from 'satcheljs';
export default action('ON_COMMIT_THEME_CHANGE', function (themeId) {
    return {
        themeId: themeId,
    };
});
//# sourceMappingURL=onCommitThemeChange.js.map